module.exports = __webpack_public_path__ + "static/media/cart.8165a691.png";